import React, { Component } from 'react'
import Modal from 'components/Modal'

import './ErrorModal.scss'
import customerSupport from '@src/services/customerSupport'

class ErrorModal extends Component {
  constructor (props) {
    super(props)

    this.handleClose = this.handleClose.bind(this)
    this.contactSupport = this.contactSupport.bind(this)

    this.state = {
      errorWasRead: false,
      count: -1
    }
  }

  componentWillReceiveProps (nextProps) {
    if (this.state.count !== nextProps.error.count) {
      this.setState({
        errorWasRead: false,
        count: nextProps.error.count
      })
    }
  }

  handleClose () {
    this.setState({
      errorWasRead: true
    })
  }

  contactSupport () {
    customerSupport.openChat()
  }

  render () {
    const { error: { message } } = this.props
    const { errorWasRead } = this.state
    const openModal = message && !errorWasRead

    return (
      <Modal
        isOpen={!!openModal}
        contentLabel='ErrorModal'
        onRequestClose={this.handleClose}
        shouldCloseOnOverlayClick >
        <p>{message}</p>

        <button
          className='btn btn-primary'
          onClick={this.contactSupport}
          >
          Contactar a Atención al Cliente
        </button>
      </Modal>
    )
  }
}

ErrorModal.displayName = 'ErrorModal'
ErrorModal.defaultProps = {
  error: ''
}

export default ErrorModal



// WEBPACK FOOTER //
// ./src/screens/App/components/ErrorModal/ErrorModal.js